import React, { useState } from 'react';
import CriticalThinking from '../../images/portfolio/NDLA/critical-thinking.png';
import FreeSpech from '../../images/portfolio/NDLA/free-speech.png'
import LiteraryAnalysis from '../../images/portfolio/NDLA/literary-analysis.png'
import PortfolioPageVideo from '../../components/PortfolioPageVideo';
import ContentWrapper from '../../components/ContentWrapper';
import { useT } from '../../i18n';

const NDLA = () => {
    const t = useT();
    return <ContentWrapper>
        <h2 className="text-center md:text-xl mt-12 mb-8">
            {t('Kritisk tenkning', 'Critical thinking')}
        </h2>
       <PortfolioPageVideo thumbnailImg={CriticalThinking} url={"https://www.youtube.com/embed/N7WHhYTnLFA?si=95MgJvIyipaSC5ai"}/>
        <h2 className="text-center md:text-xl mt-24 mb-8">
            {t('Ytringsfrihet', 'Freedom of speech')}
        </h2>
       <PortfolioPageVideo thumbnailImg={FreeSpech} url={"https://www.youtube.com/embed/ASIgaEU3cog?si=gxG38ry2fkxtskK"}  />
       <h2 className="text-center md:text-xl mt-24 mb-8">
          {t('Tekstanalyse', 'Text analysis')}
       </h2>
       <PortfolioPageVideo thumbnailImg={LiteraryAnalysis} url={"https://www.youtube.com/embed/VNFp1AThEYo?si=MDwBqZe1h3Q1SduA"}/>
          <div className="mt-16 w-full">
              <h1 className="md:text-2xl mb-4">NDLA (Klipp og Lim)</h1>
              {t(
              <p >
                Vi ble hyrt inn av Klipp og Lim, for å hjelpe dem med å produsere noen skolevideoer for <br />
                læringsplattformen NDLA. Oppgavene våre besto av å lage storyboard for manus, så lagde vi animatic <br />
                og animasjon. Vi produserte til sammen seks videoer (Ytringsfrihet, Offentlighetsbegrepet, <br />
                Intertekstualitet, Kritisk tenkning, Tekstanalyse og Bærekraftig utvikling).
                 <br /><br />
                 (2021)
              </p>,
              <p className="md:w-2/3">
                Klipp og Lim hired us to help produce educational videos for NDLA, the Norwegian digital learning platform.
                Our job was to storyboard the scripts and then make the animatics and animation.
                In total we produced six videos (Freedom of speech, The public sphere, Intertextuality,
                Critical thinking, Text analysis and Sustainable development).
                 <br /><br />
                 (2021)
              </p>
              )}
          </div>
    </ContentWrapper>

}

export default NDLA;
